import styled from 'styled-components';

export const Description = styled.div`
  ${(props) => props.theme.newTypography.textStyleBodySmall}
  color: ${(props) => props.theme.newPalette.neutral.N600};
  padding-bottom: 10px;
`;

export const HeaderWrapper = styled.div`
  ${(props) => props.theme.newTypography.textStyleBodyLargeSemibold}
  padding: 10px 0;
`;

export const FormContainer = styled.div`
  width: 100%;
`;

export const BackContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: start;
  align-items: center;
  cursor: pointer;
  color: ${(props) => props.theme.newPalette.turquoise.T300};
`;
